import dotProp from "dot-prop";
import fetch from 'isomorphic-fetch'
import { postJson } from "../api_helpers";
import store from "../store";
import { createEntityWithDefaults } from "./entities";
import { fetchEntitiesFailure } from "./entities";
import normalize from 'json-api-normalizer';


export const FETCH_INVOICES_GENERATE = 'FETCH_INVOICES_GENERATE';
export function fetchInvoicesGenerate() {
  return function(dispatch) {
    return fetch(Routes.generate_api_invoices_path(), {
       headers: {
         'X-Requested-With': 'XMLHttpRequest',
         'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
         'Content-Type': 'application/json',
         'Accept': 'application/json'
       },
       method: 'POST',
      'credentials': 'same-origin'}).then (
      response => response.json()
    ).then ()
  }
}

export function toggleInvoicePaid(invoiceId) {
  return function(dispatch) {
    postJson(Routes.toggle_payed_api_invoice_path({id: invoiceId, _options: true}), {})
  }
}

export function getProposedInvoice(dossierId) {
 return function(dispatch) {
    return postJson(Routes.generate_proposal_api_invoices_path({dossier_id: dossierId, _options: true}), {}).then (
      response => response.json(),
      error => dispatch(fetchEntitiesFailure('invoices'))
    ).then (
      json => {
        if(json.errors) {
          dispatch(fetchEntitiesFailure('invoices'))
        } else {
          let contactId = dotProp.get(store.getState(), `entities.dossier.byId.${dossierId}.patientId`)

          let invoiceItemsJson = normalize(json)['invoiceItems']
          let invoiceId = dispatch(createEntityWithDefaults('invoice', {dossierId: dossierId, receiverId: contactId, receiverType: 'Contact'}))

          if(invoiceItemsJson && Object.keys(invoiceItemsJson).length > 0) {
            Object.keys(invoiceItemsJson).forEach((key) => {
              let item = invoiceItemsJson[key]
              if( item['type'] === 'invoiceItems') {
                let consultationId = item['relationships']['consultation']['data']['id']
                dispatch(createEntityWithDefaults('invoiceItem', { invoiceId: invoiceId, consultationId: consultationId,  ...item['attributes']}))
              }
            })
          }
          return invoiceId
        }
      }
    )
  }
}
